let size: number | null = null;

/** Thickness of the browser's scrollbars in pixels (0 where they overlay the content), measured once. */
export const scrollbarSize = (): number => {
  if (size == null) {
    const probe = document.createElement('div');
    probe.style.cssText = 'position:absolute;top:-9999px;width:100px;height:100px;overflow:scroll;';
    document.body.appendChild(probe);
    size = probe.offsetHeight - probe.clientHeight;
    document.body.removeChild(probe);
  }
  return size;
}
